module.exports = __webpack_public_path__ + "static/video-layer-bcf0044dc390f21b54e3054c372dd582.jpg";